import { styled } from '../../theme/stitches.config'

export const Form = styled('form', {
  stack: '$paddingBetweenXL',
  width: '100%'
})
